<template>
  <router-link v-if="!external" :to="link" class="menu-title">
    <slot></slot>
  </router-link>

  <a v-else-if="external" :href="link" class="menu-title">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: ["external", "link"]
};
</script>
